export default "__VITE_ASSET__CxhjV141__"